import { useState } from 'react'

export const useFinancialAccountStatementDownload = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedPeriod, setSelectedPeriod] = useState<Nullable<string>>(null)

  const openModal = () => {
    setSelectedPeriod(null)
    setIsModalOpen(true)
  }

  return {
    data: {
      selectedPeriod,
    },
    methods: {
      setSelectedPeriod,
    },
    commands: {
      openModal,
      closeModal: () => setIsModalOpen(false),
    },
    states: {
      isModalOpen,
    },
  }
}
